// ExportEnglishPDF.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logoLeft from "../../assets/img/logo/new-logo.png";
import logoRight from "../../assets/img/logo/punjab-logo.png";

const ExportEnglishPDF = () => {
  const [data, setData] = useState([]);
  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    axios.get("https://ricgop.online/backend/getDuties.php").then((res) => {
      setData(res.data);
    });
  }, []);

  const exportToPDF = () => {
    const doc = new jsPDF({ orientation: "landscape" });
    const pageWidth = doc.internal.pageSize.getWidth();
    const imgLeft = new Image();
    const imgRight = new Image();

    imgLeft.src = logoLeft;
    imgRight.src = logoRight;

    const rows = data.map((d, i) => [
      i + 1,
      d.name.trim(),
      d.contact.trim(),
      d.role.trim(),
      d.section.trim(),
      d.on_call.trim(),
    ]);

    autoTable(doc, {
      head: [["#", "Name", "Contact", "Role", "Section", "On Call"]],
      body: rows,
      startY: 50,
      theme: "grid",
      headStyles: {
        fillColor: [0, 102, 204],
        textColor: 255,
        fontSize: 12,
      },
      styles: {
        fontSize: 10,
        halign: "center",
      },
      didDrawPage: () => {
        doc.addImage(imgLeft, "PNG", 10, 15, 25, 22);
        doc.addImage(imgRight, "PNG", pageWidth - 35, 15, 25, 25);
        doc.setFontSize(20);
        doc.setFont("helvetica", "bold");
        doc.text("Rawalpindi Institute of Cardiology", pageWidth / 2, 25, {
          align: "center",
        });
        doc.setFontSize(12);
        doc.text(`Duty Roster - (${today})`, pageWidth / 2, 35, {
          align: "center",
        });
      },
    });

    doc.save(`Duty-Roster-English-${today}.pdf`);
  };

  return (
    <div className="container mt-4">
      <h5>📄 Export Duty Roster (English)</h5>
      <button className="btn btn-primary" onClick={exportToPDF}>
        Export PDF
      </button>
    </div>
  );
};

export default ExportEnglishPDF;
